/** Query parameter names shared by Set BoM rules and the detached test view. */
export const BOM_DEEP_LINK = {
  templateId: "templateId",
  revision: "revision",
  testSku: "testSku",
  /** Alias: failing SKU for deep links that resolve template via the API. */
  sku: "sku",
  tab: "tab",
} as const;

/**
 * Tries to pull the problematic SKU from a BoM/forecast error message for deep linking.
 * Matches the strings emitted by the database and API (for example, "Original SKU: …").
 */
export function extractBomFailingSkuFromErrorMessage(message: string): string | null {
  const fromOriginal = /Original SKU:\s*([^\s]+)/i.exec(message);
  if (fromOriginal?.[1]) {
    return fromOriginal[1].replace(/\.$/, "").trim();
  }
  const fromLeft = /Unprocessed characters left in SKU:\s*([^\s]+)/i.exec(message);
  if (fromLeft?.[1]) {
    return fromLeft[1].replace(/\.$/, "").trim();
  }
  return null;
}

/**
 * Set BoM rules: prefill the parse tab, resolve `templateId` and `revision` on load when only `sku` is known.
 */
export function buildSetBomRulesDeepLink(failingSku: string, options?: { tab?: "parse" | "initial" | "rules" }): string {
  const p = new URLSearchParams();
  p.set(BOM_DEEP_LINK.sku, failingSku);
  p.set(BOM_DEEP_LINK.tab, options?.tab ?? "parse");
  return `/bom/set-bom-rules?${p.toString()}`;
}
